window.addEventListener("DOMContentLoaded", () => {
    let activeCategory = "all";

    const categoryButtons: Array<HTMLElement> = Array.from(
        document.querySelectorAll(".blog-category-selection")
    );

    const articles: Array<HTMLElement> = Array.from(
        document.querySelectorAll(".blog-article-preview")
    );

    categoryButtons.forEach((button: HTMLElement) => {
        button.classList.add("active");
        const buttonCategory = button.className
            .split(" ")
            .filter((className) => className.startsWith("category-"))[0];
        button.addEventListener("click", (evt) => {
            evt.preventDefault();
            evt.stopPropagation();
            button.blur();
            const buttonCategory = button.className
                .split(" ")
                .filter((className) => className.startsWith("category-"))[0];
            if (activeCategory !== buttonCategory) {
                activeCategory = buttonCategory;
                categoryButtons.forEach((button: HTMLElement) => {
                    button.classList.remove("active");
                });
                button.classList.add("active");
            } else {
                activeCategory = "all";
                categoryButtons.forEach((button: HTMLElement) => {
                    button.classList.add("active");
                });
            }
            applyCategoryFilter(activeCategory);
        });
    });

    function applyCategoryFilter(activeCategory: string) {
        articles.forEach((article) => {
            const articleCategories = article.className
                .split(" ")
                .filter((className) => className.startsWith("category-"));
            let showArticle = false;
            articleCategories.forEach((articleCategory) => {
                if (showArticle) {
                    return;
                }
                if (["all", articleCategory].includes(activeCategory)) {
                    showArticle = true;
                }
            });
            if (showArticle) {
                article.classList.add("active");
            } else {
                article.classList.remove("active");
            }
        });
    }
});
